'use strict';

import { forEach } from 'lodash';
import ScrollReveal from 'scrollreveal';

let aboutPage = function () {

  console.debug('About category');

  // Client logo-grid reveal
  // =================================================
  if ($('.grid-logos__item').length) {

    let scrollReveal = ScrollReveal();

    if (!scrollReveal.isSupported()) {
      $('html').addClass('no-scrollreveal');
    }

    scrollReveal.reveal('.grid-logos__item', {
      delay: 200,
      duration: 400,
      distance: '2rem',
      easing: 'cubic-bezier(0.455, 0.030, 0.515, 0.955)',
      opacity: 0,
      scale: 1
    }, 100);
  }

  // Contact form
  // =================================================
  $('#contact-form').on('submit', function (event) {
    event.preventDefault();

    // clear any errors
    $(this).find('.errors').remove();

    // get post data
    let data = $(this).serialize();

    // cache selectors
    let $spinner = $('.js-loading-spinner');
    let $btnSubmit = $('.js-btn-submit');
    let $confirmMessage = $('.form-confirmation');
    let clearableInputs = 'input[type=text], input[type=email], textarea';
    let $self = $(this);

    // replace 'SEND' button with loading spinner
    $spinner.addClass('is-active');
    $btnSubmit.attr('disabled', true).addClass('is-hidden');

    // handle the request
    $.post('/', data)
      .done(function (response) {
        if (response.success) {
          $spinner.removeClass('is-active');
          // Clear the form
          $self.find(clearableInputs).val('');
          // Show confirmation for a couple seconds and then set back to normal
          $confirmMessage.addClass('is-visible');
          setTimeout(function () {
            $confirmMessage.removeClass('is-visible');
            $spinner.removeClass('is-active');
            $btnSubmit.attr('disabled', false).removeClass('is-hidden');
          }, 2000);
        } else {
          // response.error will be an object containing any validation errors
          // that occurred, indexed by field name
          // e.g. response.error.fromName => ['From Name is required']
          forEach(response.error, function (errors, fieldName) {
            $(`#${fieldName}`).after(`<ul class="errors errors--${fieldName}"></ul>`);
            forEach(errors, function (error) {
              $(`.errors--${fieldName}`).append(`<li>${error}</li>`);
            });
          });
          // Set back to normal
          setTimeout(function () {
            $spinner.removeClass('is-active');
            $btnSubmit.attr('disabled', false).removeClass('is-hidden');
          }, 500);
        }
      })
      .fail(function () {
        alert('Sorry, there was an error. We apologize for any inconvenience.');
      });

  });

};

export default aboutPage;



// WEBPACK FOOTER //
// ./aboutPage.js